var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 513,
    viewBox: "0 0 513 513",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_1135)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 495,
    height: 495,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.484,
    y: 9,
    width: 17.2421,
    height: 168,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.727,
    y: 9,
    width: 17.2421,
    height: 168,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 9,
    width: 17.2421,
    height: 168,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.242,
    y: 9,
    width: 17.2421,
    height: 168,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 153L128.761 8.25001L384.239 8.25003L256.5 153Z",
    fill: "#0098FD"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257,
    y1: 131,
    x2: 257,
    y2: 434,
    stroke: "#0098FD",
    strokeWidth: 18
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 495,
    height: 495,
    rx: 32,
    stroke: "#5D647B",
    strokeWidth: 17
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_1135"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 495,
    height: 495,
    rx: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffLight);
export default __webpack_public_path__ + "static/media/offLight.f2542857bce1d17ecdfa133ce81dc74e.svg";
export { ForwardRef as ReactComponent };